import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';
import { nanoid } from 'nanoid';

function Menu() {
  const { allSanityMenu } = useStaticQuery(graphql`
    {
      allSanityMenu(sort: { fields: _createdAt, order: ASC }) {
        nodes {
          product {
            heading
            item {
              price
              title
            }
          }
          title
        }
      }
    }
  `);

  return (
    <article className="relative px-4 py-12 mx-auto bg-slate">
      <div className="w-full max-w-2xl py-8 mx-auto space-y-12 bg-white rounded-lg lg:py-12">
        {allSanityMenu.nodes.map((menu) => (
          <div key={nanoid()} className="focus:outline-none focus:ring">
            <div className="flex-1 px-4 lg:px-12">
              <div className="py-2 mx-auto border-b-4 border-dashed border-slate">
                <h2
                  dangerouslySetInnerHTML={{ __html: menu.title }}
                  className="text-2xl font-black uppercase md:text-3xl lg:text-4xl font-display"
                />
              </div>
              {menu.product.map((product) => (
                <div key={nanoid()} className="divide-y-2 divide-slate">
                  <div className="flex flex-col mt-8" key={nanoid()}>
                    <table className="min-w-full">
                      <thead>
                        <tr>
                          <th
                            colSpan={2}
                            className="py-3 font-normal text-left uppercase font-display"
                          >
                            {product.heading}
                          </th>
                          {product.heading === product.item[0].title && (
                            <th
                              colSpan={2}
                              className="py-3 text-right whitespace-nowrap"
                            >
                              ${Number(product.item[0].price).toFixed(2)}
                            </th>
                          )}
                        </tr>
                      </thead>
                      {product.heading !== product.item[0].title && (
                        <tbody className="bg-white">
                          {product.item.map((item) => (
                            <tr key={nanoid()}>
                              <td className="py-2">{item.title}</td>
                              <td className="py-2 text-right whitespace-nowrap">
                                <strong>
                                  ${Number(item.price).toFixed(2)}
                                </strong>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      )}
                    </table>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </article>
  );
}

export { Menu };
